import { render, staticRenderFns } from "./employeeDetailsModal.vue?vue&type=template&id=67698a08"
import script from "./employeeDetailsModal.vue?vue&type=script&lang=js"
export * from "./employeeDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports